export default function PHP_is_string() {
  return (
    <div>
      <h1>PHP_is_string</h1>
    </div>
  );
}
